import ContactProfileForm from "@components/Forms/ContactProfileForm";
import { TitleWithDivider } from "@common/TitleWithDivider";
import pageHeaders from "@constants/PageHeaders";

const CreateContactPage: React.FC = () => {
  return (
    <>
      <div>
        <TitleWithDivider
          titleText={pageHeaders.KAKELY.phonebookAdd}
          useDivider={true}
        />
        <ContactProfileForm id={"createInternalContact"}></ContactProfileForm>
      </div>
    </>
  );
};

export default CreateContactPage;
